import cfg from 'cfg';
import auth from 'dash-front/auth';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import { USER_ACTIONS } from '../../reducers/user';

const radioButtonStyles = {
    marginBottom: 16,
};

class CampaignsList extends Component {
    state = {
        defaultCampaignId: (this.props.user && this.props.user.defaultCampaignId) || '',
        campaigns: [],
    };

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        fetch(`${cfg.campaign_manager.host}/api/campaigns?access_token=${auth.getAccessToken()}`)
            .then(res => res.json())
            .then(({ campaigns }) => {
                this.setState({ campaigns });
            })
            .catch(error => {
                console.error(error);
            });
    };

    handleCampaignDefault = (event, defaultCampaignId) => {
        const { _id: userId } = this.props.user;

        return fetch(`${cfg.dash.api.host}/api/users/${userId}?access_token=${auth.getAccessToken()}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                defaultCampaignId,
            }),
        })
            .then(res => res.json())
            .then(() => {
                auth.saveUser({ ...this.props.user, defaultCampaignId });
                this.props.updateUser({ ...this.props.user, defaultCampaignId });

                this.setState({
                    defaultCampaignId,
                });
            })
            .catch(error => {
                console.error(error);
            });
    };

    render() {
        return (
            <div>
                <RadioButtonGroup
                    name="campaign_default"
                    defaultSelected={this.state.defaultCampaignId}
                    onChange={this.handleCampaignDefault}
                >
                    {this.state.campaigns
                        .filter(({ calendar }) => calendar)
                        .map(({ _id: id, title }) => (
                            <RadioButton key={id} value={id} label={title} style={radioButtonStyles} />
                        ))}
                </RadioButtonGroup>
            </div>
        );
    }
}

CampaignsList.defaultProps = { user: { defaultCampaignId: '' } };

CampaignsList.propTypes = {
    user: PropTypes.shape({
        _id: PropTypes.string.isRequired,
        defaultCampaignId: PropTypes.string,
    }).isRequired,
    updateUser: PropTypes.func.isRequired,
};

export default connect(
    ({ user }) => ({ user }),
    {
        updateUser: user => ({ type: USER_ACTIONS.UPDATE, payload: user }),
    },
)(CampaignsList);



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/account/CampaignsList.js
 **/